//
// Common color aliases
// ====================
//
// These are aliases to standard appLevel colors. For example, if you want to use the "text color"
// rather than grape soda, this is what you're looking for.
//
// For named colors aliases, see palette.styl!
//
import * as palette from './palette';

export const colorAppBackground = palette.colorWhite;
export const colorAppText = palette.colorBlackout;
export const colorAppLink = palette.colorPunch;
export const colorAppSecondaryText = palette.colorStorm;
export const colorAppBorder = palette.colorFog;
export const colorAppShadedBackground = palette.colorDew;
export const colorAppIcon = palette.colorRain;
export const colorAppIconHover = palette.colorSoda;

export const colorAppHighlightBackground = colorAppShadedBackground;
export const colorAppError = palette.colorHollywood;
export const colorAppSuccess = palette.colorMoney;
export const colorAppAdmin = palette.colorConfetti;
export const colorAppAdminSecondary = palette.colorCake;
export const colorAppUpsell = palette.colorConfetti;
export const colorAppUpsellSecondary = palette.colorCake;

export const colorAppFieldText = colorAppText;
export const colorAppFieldBackground = colorAppBackground;
export const colorAppFieldSecondaryBackground = colorAppShadedBackground;
export const colorAppFieldIcon = palette.colorRain;
export const colorAppFieldBorder = palette.colorRain;
export const colorAppFieldBorderHover = palette.colorPunch;
export const colorAppFieldBorderFocus = palette.colorPunch;

export const colorAppLabelText = palette.colorBlackout;
export const colorAppPlaceholderText = palette.colorRain;

export const colorAppErrorText = colorAppError;
export const colorAppErrorPlaceholderText = palette.colorCowabunga;

export const colorAppShadow = palette.colorBlackShadowDark;
export const colorAppContainerShadow = palette.colorBlackShadow;
export const colorAppContainerBackground = palette.colorWhite;

export const colorAppModalOverlay = palette.colorSoda;
export const colorAppLoadingOverlay = palette.colorWhiteTransparent;

export const colorAppEditModeText = palette.colorWhite;
export const colorAppEditModeBackground = palette.colorTwister;
export const colorAppEditModeHighlightBackground = palette.colorStorm;
export const colorAppEditModeAccentText = palette.colorBlack;
export const colorAppEditModeAccentBackground = palette.colorFog;
